<template>
  <div class="ivan-group-list">
    <div v-if="showSearch" class="form-group ivan-group-list__search">
      <div class="has-feedback">
        <input
          v-model="keyword"
          class="form-control input-sm"
          placeholder="关键字搜索"
          @input="$emit('filter', keyword)"
        />
        <span class="fa fa-search form-control-feedback" aria-hidden="true" />
      </div>
    </div>

    <div v-for="g in filteredGroups" :key="g.key">
      <div class="anCore-groupPanel-heading" @click="g.expand = !g.expand">
        <i class="fa fa-sort-desc" :class="{ 'fa-rotate-270': !g.expand }" />
        <span>{{ g.key }}</span>
        <span>({{ g.items.length }})</span>
      </div>
      <div v-show="g.expand">
        <div
          v-for="p in g.items"
          :key="p.xmbh"
          class="list-group-item anCore-groupPanel-item"
          :class="{ 'anCore-item-active': currentXmbh === p.xmbh }"
          @click="$emit('select', p)"
        >
          <div style="margin-bottom:5px;">
            <div
              class="anCore-text-overflow"
              :style="{ width: 'calc(100% - 80px)', display: 'inline-block', fontWeight: boldTitle ? 'bold' : 'normal' }"
              :title="p.ProjectName"
            >
              {{ p.ProjectName }}
            </div>
            <div class="pull-right text-right text-muted" style="width:80px;" :title="p.ProjectDate">
              <span class="small">{{ displayDate(p) }}</span>
            </div>
          </div>
          <div class="text-muted small">
            <div
              class="anCore-text-overflow"
              :style="{ width: trackMode ? 'calc(100% - 200px)' : 'calc(100% - 80px)', display: 'inline-block' }"
            >
              <template v-if="trackMode">
                <span>[</span>
                <span v-for="(a, i) in (p.ActList || [])" :key="i">{{ a }}</span>
                <span>]进行中</span>
              </template>
              <template v-else>{{ p.WfCaseState }}</template>
            </div>
            <div class="pull-right">
              <span v-if="trackMode" style="margin-right:5px;">{{ p.ProjectCode }}</span>
              <span>{{ p.ProjectType }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!filteredGroups.length" class="text-center text-muted" style="padding:40px 10px;">
      {{ emptyText }}
    </div>
  </div>
</template>

<script>
import { formatListDate, groupDateLabel } from '@/utils/pickAdminAdapter'

export default {
  name: 'IvanGroupProjectList',
  props: {
    groups: { type: Array, default: () => [] },
    currentXmbh: { type: String, default: '' },
    showSearch: { type: Boolean, default: false },
    trackMode: { type: Boolean, default: false },
    boldTitle: { type: Boolean, default: false },
    emptyText: { type: String, default: '暂无待处理采样任务' }
  },
  data() {
    return { keyword: '' }
  },
  computed: {
    filteredGroups() {
      const kw = String(this.keyword || '').trim().toLowerCase()
      if (!kw) return this.groups
      return this.groups
        .map(g => ({
          ...g,
          items: (g.items || []).filter(p => {
            const hay = [p.ProjectName, p.ProjectCode, p.ProjectType, p.WfCaseState]
              .join(' ')
              .toLowerCase()
            return hay.indexOf(kw) >= 0
          })
        }))
        .filter(g => g.items.length)
    }
  },
  methods: {
    displayDate(p) {
      return formatListDate(p.ProjectDate || p.CreateDate)
    },
    groupDateLabel
  }
}
</script>

<style scoped>
.ivan-group-list__search {
  min-height: 30px;
  padding: 6px 8px 0;
}
.ivan-group-list__search .has-feedback {
  position: relative;
  display: block;
}
.ivan-group-list__search .form-control {
  padding-right: 28px;
}
.ivan-group-list__search .form-control-feedback {
  position: absolute;
  right: 8px;
  top: 7px;
  color: #999;
}
.anCore-groupPanel-heading {
  cursor: pointer;
  padding: 8px 10px;
  background: #f5f7fa;
  border-bottom: 1px solid #e8e8e8;
  font-size: 13px;
}
.anCore-groupPanel-item {
  cursor: pointer;
  padding: 10px 12px;
  border: none;
  border-left: 0;
  border-right: 0;
  border-bottom: 1px solid #f0f0f0;
  border-radius: 0;
  background: #fff;
  color: #333;
  min-height: 40px;
}
.anCore-groupPanel-item:hover,
.anCore-groupPanel-item:focus {
  outline: none;
  box-shadow: none;
  background: #f0f7ff;
  color: #333;
}
/* 对齐 Ivan AnCore/CSS/ui-framework.less .anCore-item-active：左蓝条 + 浅蓝底，无白字 */
.anCore-groupPanel-item.anCore-item-active,
.list-group-item.anCore-groupPanel-item.anCore-item-active,
.anCore-groupPanel-item.anCore-item-active:hover,
.anCore-groupPanel-item.anCore-item-active:focus {
  border-left: 3px solid #337ab7 !important;
  background-color: #d9edf7 !important;
  margin-left: 1px;
  color: #333 !important;
  outline: none !important;
  box-shadow: none !important;
  z-index: auto;
}
.anCore-groupPanel-item.anCore-item-active .anCore-text-overflow {
  color: #333 !important;
}
.anCore-groupPanel-item.anCore-item-active .text-muted,
.anCore-groupPanel-item.anCore-item-active .text-muted.small,
.anCore-groupPanel-item.anCore-item-active .small {
  color: #888 !important;
}
.anCore-text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
.fa-rotate-270 {
  transform: rotate(-90deg);
}
</style>
